// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import XIcon from '../_raw/ui/icon_x.svg';
import withIconProps from '../withIconProps';

export default withIconProps(XIcon);
